// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__192FC","label":"Labeled_label__p7dou","divider":"Labeled_divider__3VAKi"};